<template>
  <b-modal
    ref="pickingWarningModal"
    title="Confirm"
    ok-title="Confirm"
    cancel-title="Cancel"
    ok-variant="danger"
    @ok="confirm"
  >
    <p>
      You picked items that are not part of the order are you sure you want to
      proceed ?
    </p>
  </b-modal>
</template>

<script>
export default {
  name: "pickingwarning-modal",
  methods: {
    confirm() {
      this.hideModal();
      this.$parent.handlePickingNote();
    },
    showModal() {
      this.$refs.pickingWarningModal.show();
    },
    hideModal() {
      this.$refs.pickingWarningModal.hide();
    }
  }
};
</script>
